import {
  FILE_TYPE_LABELS,
  FILE_TYPES,
  formatCount,
  regionFullLabel,
  regionPassRate,
  regionShortLabel,
  regionTotalFiles,
} from "../adminReportUtils";
import { RegionCode, RegionReport } from "../types";
import Chip from "./chip";
import PassRateMeter from "./passRateMeter";

interface RegionalPerformanceTableProps {
  regions: RegionReport[];
  onRegionClick: (region: RegionCode) => void;
}

const RegionalPerformanceTable = ({
  regions,
  onRegionClick,
}: RegionalPerformanceTableProps) => (
  <table className="admin-report__table">
    <thead>
      <tr>
        <th>Region</th>
        {/* Numeric headers right-align so each one sits over its own column. */}
        {FILE_TYPES.map((fileType) => (
          <th key={fileType} className="admin-report__table-number">
            {FILE_TYPE_LABELS[fileType]}
          </th>
        ))}
        <th className="admin-report__table-number">Total Files</th>
        <th className="admin-report__table-number">Test Cases</th>
        <th>Pass Rate</th>
      </tr>
    </thead>
    <tbody>
      {regions.map((report) => (
        <tr
          key={report.region}
          className="is-clickable"
          onClick={() => onRegionClick(report.region)}
          title={`View ${regionFullLabel(report.region)} documents`}
        >
          <td>
            <Chip tone="blue">{regionShortLabel(report.region)}</Chip>
          </td>
          {FILE_TYPES.map((fileType) => (
            <td key={fileType} className="admin-report__table-number">
              {formatCount(report.fileCounts[fileType])}
            </td>
          ))}
          <td className="admin-report__table-number--strong">
            {formatCount(regionTotalFiles(report))}
          </td>
          <td className="admin-report__table-number">
            {formatCount(report.testCaseCount)}
          </td>
          <td>
            <PassRateMeter passRate={regionPassRate(report)} />
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);

export default RegionalPerformanceTable;
